import { apiClient } from '../apiClient';

const getTokenHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getWeeklyReportSummary = async (params = {}) => {
  try {
    const response = await apiClient.get('/pmiDevices/reports/weekly-summary', {
      params,
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching weekly report summary:', error);
    throw error;
  }
};

export const sendWeeklyReportEmail = async (payload = {}) => {
  try {
    const response = await apiClient.post('/pmiDevices/reports/weekly-summary/email', payload, {
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error sending weekly report email:', error);
    throw error;
  }
};

export const getQaDigestEmailLogs = async (params = {}) => {
  try {
    const response = await apiClient.get('/pmiDevices/reports/qa-digest/logs', {
      params,
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching QA digest email logs:', error);
    throw error;
  }
};

export const listInactiveEscalationRecipients = async (role = '') => {
  try {
    const response = await apiClient.get('/pmiDevices/reports/inactive-escalation-recipients', {
      params: role ? { role } : {},
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error loading inactive escalation recipients:', error);
    throw error;
  }
};

export const saveInactiveEscalationRecipient = async (payload = {}) => {
  try {
    const response = await apiClient.post('/pmiDevices/reports/inactive-escalation-recipients', payload, {
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error saving inactive escalation recipient:', error);
    throw error;
  }
};

export const deleteInactiveEscalationRecipient = async (id) => {
  try {
    const response = await apiClient.delete(`/pmiDevices/reports/inactive-escalation-recipients/${encodeURIComponent(id)}`, {
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting inactive escalation recipient:', error);
    throw error;
  }
};

export const getInactiveEscalationPolicy = async (profileKey = '') => {
  try {
    const response = await apiClient.get('/pmiDevices/reports/inactive-escalation-policy', {
      params: profileKey ? { profileKey } : {},
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching inactive escalation policy:', error);
    throw error;
  }
};

export const getInactiveEscalationPreview = async (params = {}) => {
  try {
    const response = await apiClient.get('/pmiDevices/reports/inactive-escalation-preview', {
      params,
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching inactive escalation preview:', error);
    throw error;
  }
};

export const sendInactiveEscalationEmail = async (payload = {}) => {
  try {
    const response = await apiClient.post('/pmiDevices/reports/inactive-escalation/email', payload, {
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error building/sending inactive escalation email:', error);
    throw error;
  }
};

export const sendInactiveEscalation24hEmail = async (payload = {}) => {
  try {
    const response = await apiClient.post('/pmiDevices/reports/inactive-escalation-24h/email', payload, {
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error building/sending inactive escalation 24h email:', error);
    throw error;
  }
};

export const listInactiveEscalationConfigs = async () => {
  try {
    const response = await apiClient.get('/pmiDevices/reports/inactive-escalation-configs', {
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching inactive escalation config list:', error);
    throw error;
  }
};

export const getInactiveEscalationConfig = async (profileKey = '') => {
  try {
    const response = await apiClient.get('/pmiDevices/reports/inactive-escalation-config', {
      params: profileKey ? { profileKey } : {},
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching inactive escalation config:', error);
    throw error;
  }
};

export const createInactiveEscalationConfig = async (payload = {}) => {
  try {
    const response = await apiClient.post('/pmiDevices/reports/inactive-escalation-config', payload, {
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error creating inactive escalation config:', error);
    throw error;
  }
};

export const updateInactiveEscalationConfig = async (payload = {}) => {
  try {
    const response = await apiClient.put('/pmiDevices/reports/inactive-escalation-config', payload, {
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error updating inactive escalation config:', error);
    throw error;
  }
};

export const setDefaultInactiveEscalationConfig = async (profileKey) => {
  try {
    const response = await apiClient.post(
      `/pmiDevices/reports/inactive-escalation-config/${encodeURIComponent(profileKey)}/set-default`,
      {},
      {
        headers: getTokenHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error setting default inactive escalation config:', error);
    throw error;
  }
};

export const getInactiveEscalationSelectorSuggestions = async (params = {}) => {
  try {
    const response = await apiClient.get('/pmiDevices/reports/inactive-escalation-selector-suggestions', {
      params,
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching inactive escalation selector suggestions:', error);
    throw error;
  }
};
